/**
 * Fix globale warning ARIA su modali Bootstrap 5.
 * Stesso pattern inert di Weext createModal.ts, applicato via event delegation.
 */
export function initModalAriaFix(): void {
  document.addEventListener('hide.bs.modal', (e: Event) => {
    (e.target as HTMLElement).setAttribute('inert', '');
  });

  document.addEventListener('shown.bs.modal', (e: Event) => {
    (e.target as HTMLElement).removeAttribute('inert');
  });
}
